import { css } from 'styled-components';

// Neumorphism color palette
export const neumorphismColors = {
  light: '#f0f0f3',
  dark: '#d1d9e6',
  shadow: 'rgba(174, 174, 192, 0.4)',
  highlight: 'rgba(255, 255, 255, 0.7)',
  text: '#2d3748',
  textLight: '#718096'
};

// Base neumorphism card styles
export const neumorphismCard = css`
  background: white;
  border-radius: 20px;
  box-shadow: 
    8px 8px 16px rgba(0, 0, 0, 0.1),
    -8px -8px 16px rgba(255, 255, 255, 0.8);
  border: none;
  transition: all 0.3s ease;
`;

// Elevated neumorphism card with stronger shadows for better depth
export const neumorphismCardElevated = css`
  background: white;
  border-radius: 20px;
  box-shadow: 
    12px 12px 24px rgba(0, 0, 0, 0.25),
    -8px -8px 16px rgba(0, 0, 0, 0.05),
    0 0 0 1px rgba(0, 0, 0, 0.1);
  border: none;
  transition: all 0.3s ease;
`;

// Pressed/active neumorphism effect
export const neumorphismPressed = css`
  box-shadow: 
    inset 20px 20px 60px ${neumorphismColors.shadow},
    inset -20px -20px 60px ${neumorphismColors.highlight};
`;

// Hover effect for neumorphism cards
export const neumorphismHover = css`
  &:hover {
    transform: translateY(-2px);
    box-shadow: 
      12px 12px 24px rgba(0, 0, 0, 0.15),
      -12px -12px 24px rgba(255, 255, 255, 0.9);
  }
`;

// Active/pressed state for neumorphism cards
export const neumorphismActive = css`
  &:active {
    transform: translateY(1px);
    box-shadow: 
      inset 8px 8px 16px rgba(0, 0, 0, 0.1),
      inset -8px -8px 16px rgba(255, 255, 255, 0.8);
  }
`;

// Neumorphism button styles
export const neumorphismButton = css`
  background: white;
  border-radius: 15px;
  box-shadow: 
    6px 6px 12px rgba(0, 0, 0, 0.1),
    -6px -6px 12px rgba(255, 255, 255, 0.8);
  border: none;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 
      8px 8px 16px rgba(0, 0, 0, 0.15),
      -8px -8px 16px rgba(255, 255, 255, 0.9);
  }
  
  &:active {
    transform: translateY(1px);
    box-shadow: 
      inset 6px 6px 12px rgba(0, 0, 0, 0.1),
      inset -6px -6px 12px rgba(255, 255, 255, 0.8);
  }
`;

// Neumorphism input styles
export const neumorphismInput = css`
  background: ${neumorphismColors.light};
  border-radius: 15px;
  box-shadow: 
    inset 5px 5px 10px ${neumorphismColors.shadow},
    inset -5px -5px 10px ${neumorphismColors.highlight};
  border: none;
  padding: 15px 20px;
  transition: all 0.3s ease;
  
  &:focus {
    outline: none;
    box-shadow: 
      inset 5px 5px 10px ${neumorphismColors.shadow},
      inset -5px -5px 10px ${neumorphismColors.highlight},
      0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

// Colored neumorphism variants
export const createColoredNeumorphism = (color) => css`
  background: ${color};
  border-radius: 20px;
  box-shadow: 
    20px 20px 60px ${color}dd,
    -20px -20px 60px ${color}dd;
  border: none;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 
      25px 25px 75px ${color}dd,
      -25px -25px 75px ${color}dd;
  }
`;

// Gradient neumorphism variant
export const createGradientNeumorphism = (gradient) => css`
  background: ${gradient};
  border-radius: 20px;
  box-shadow: 
    20px 20px 60px rgba(0,0,0,0.2),
    -20px -20px 60px rgba(255,255,255,0.1);
  border: none;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 
      25px 25px 75px rgba(0,0,0,0.25),
      -25px -25px 75px rgba(255,255,255,0.15);
  }
`;
